/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const customerAssignmentCreateResponseOutputAssignmentIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerAssignmentCreateResponseOutputAssignmentCustomerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerAssignmentCreateResponseOutputAssignmentTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerAssignmentCreateResponseOutputAssignmentTeamNameMax = 100;

export const customerAssignmentCreateResponseOutputAssignmentAssignedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const customerAssignmentCreateResponseOutputAggregateCustomerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerAssignmentCreateResponseOutputAggregateCustomerVersionExclusiveMin = 0;
export const customerAssignmentCreateResponseOutputAggregateCustomerVersionMax = 9007199254740991;

export const customerAssignmentCreateResponseOutputAggregateUpdatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);

export const CustomerAssignmentCreateResponseOutput = zod.object({
  assignment: zod.object({
    id: zod.uuid().regex(customerAssignmentCreateResponseOutputAssignmentIdRegExp),
    customerId: zod.uuid().regex(customerAssignmentCreateResponseOutputAssignmentCustomerIdRegExp),
    teamId: zod.uuid().regex(customerAssignmentCreateResponseOutputAssignmentTeamIdRegExp),
    teamName: zod.string().min(1).max(customerAssignmentCreateResponseOutputAssignmentTeamNameMax),
    assignedAt: zod.iso
      .datetime({ offset: true })
      .regex(customerAssignmentCreateResponseOutputAssignmentAssignedAtRegExp),
  }),
  aggregate: zod.object({
    customerId: zod.uuid().regex(customerAssignmentCreateResponseOutputAggregateCustomerIdRegExp),
    customerVersion: zod
      .int()
      .gt(customerAssignmentCreateResponseOutputAggregateCustomerVersionExclusiveMin)
      .max(customerAssignmentCreateResponseOutputAggregateCustomerVersionMax),
    updatedAt: zod.iso
      .datetime({ offset: true })
      .regex(customerAssignmentCreateResponseOutputAggregateUpdatedAtRegExp),
  }),
});

export type CustomerAssignmentCreateResponseOutput = zod.input<
  typeof CustomerAssignmentCreateResponseOutput
>;
export type CustomerAssignmentCreateResponseOutputOutput = zod.output<
  typeof CustomerAssignmentCreateResponseOutput
>;
